import { useState, useEffect } from 'react';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

function getWindowParams() {
  let windowDimensions = getWindowDimensions();

  if (windowDimensions.height <= 1000 && windowDimensions.width < 688 ) {
    windowDimensions.device = 'mobile';
  } else {
    windowDimensions.device = 'desktop';
  }

  return windowDimensions
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowParams());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowParams());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}



// WEBPACK FOOTER //
// ./src/hooks/useWindowDimensions.js